/**
 * Format currency for European/Portuguese locale
 * Uses comma (,) as decimal separator and dot (.) as thousands separator
 * @param {number} value - The value to format
 * @returns {string} Formatted currency string
 */
export const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value || 0);
};

/**
 * Format percentage for European/Portuguese locale
 * @param {number} value - The percentage value
 * @returns {string} Formatted percentage string
 */
export const formatPercentage = (value) => {
  return new Intl.NumberFormat('pt-PT', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value || 0) + '%';
};

/**
 * Format number for European/Portuguese locale
 * Uses comma (,) as decimal separator
 * @param {number} value - The value to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number string
 */
export const formatNumber = (value, decimals = 2) => {
  return new Intl.NumberFormat('pt-PT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value || 0);
};

/**
 * Format date for Portuguese locale
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('pt-PT');
};

/**
 * Format date with time for Portuguese locale
 * @param {string|Date} date - The date to format
 * @returns {string} Formatted date/time string
 */
export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('pt-PT');
};
